export default [
    {
        name: 'appraisal',
        path: '/appraisal',
        meta: { anonymous: true, showSidebar: false, showScrollbar: false, noBackground: true },
        component: () => import(/* webpackChunkName: "appraisal" */ '../../views/Form/Appraisal.vue'),
    },

]
